import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled, { ThemeProvider } from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { useEffect, useState, useLayoutEffect } from 'react'
import Cover from 'components/Cover'
import ProjectsList from 'components/ProjectsList'
import { initializeApp } from 'firebase/app'
import InfoWindow from 'components/InfoWindow'
import { device } from '../../breakpoints'
import { RiArrowDropDownLine } from 'react-icons/ri'
import { useSpring, animated } from '@react-spring/web'
import PriceInfo from 'components/PriceInfo/'
import smoothscroll from 'smoothscroll-polyfill'
import { BsArrowRightShort } from 'react-icons/bs'
import { YearContext } from 'contexts'

smoothscroll.polyfill()

const firebaseConfig = {
  apiKey: 'AIzaSyBGF-_kiDVID2D9_8A8i4zLtHWYxG704yA',
  authDomain: 'wch-streaming-tipps.firebaseio.com',
  databaseURL:
    'https://2023-08-bilan-prix-immobilier.europe-west1.firebasedatabase.app/',
  storageBucket: 'wch-interactive.appspot.com',
  projectId: 'wch-interactive',
}

initializeApp(firebaseConfig)

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [selectedYear, setSelectedYear] = useState<number>(2026)
  const isMobile = window.innerWidth < 768
  const urlParam = new URLSearchParams(window.location.search).get('projet')
  const priceParam = new URLSearchParams(window.location.search).has('le-prix')
  const [data, setData] = useState([])
  const [category, setCategory] = useState<string | null>(null)
  const [updatedDate, setUpdatedDate] = useState<Date | null>(null)
  const [selectedId, setSelectedId] = useState<string | null>(null)
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null)
  const [categories, setCategories] = useState<string[]>([])
  const [showPriceInfo, setShowPriceInfo] = useState<boolean>(false)
  const [ref, setRef] = useState<HTMLDivElement | null>(null)
  const theme = {
    colorMode: colorMode,
    colorMain: colorMode === 'dark' ? '#ff515f' : '#ff515f',
    colorMainInverted: colorMode === 'dark' ? '#aa0a0c' : '#e9e9e9',
    colorText: colorMode === 'dark' ? '#333333' : '#333333',
    colorTextInverted: colorMode === 'dark' ? '#e9e9e9' : '#e9e9e9',
    colorLine: colorMode === 'dark' ? '#333333' : '#333333',
    colorGrey: colorMode === 'dark' ? 'var(--line-color)' : 'var(--line-color)',
    colorGreyLight: colorMode === 'dark' ? '#ffffff' : '#f2f4f7',
    colorGreyDark: colorMode === 'dark' ? '#777777' : '#777777',
    colorPrimaryButtonText: colorMode === 'dark' ? '#ffffff' : '#ffffff',
    colorPrimaryButtonBackground: colorMode === 'dark' ? '#d74d4f' : '#d74d4f',
    colorBlocBackground: colorMode === 'dark' ? '#f9f8f6' : '#f9f8f6',
  }

  useEffect(() => {
    setSelectedId(urlParam)
    priceParam && setShowPriceInfo(true)

    const url = `https://storage.googleapis.com/wch-interactive/bilan-prix-immobilier/list-${selectedYear}.json`

    fetch(url)
      .then((response) => response.json())
      .then((json) => {
        setUpdatedDate(new Date(json.updated))
        // console.log(json.data)
        setData(
          json.data.map((data: any) => ({
            ...data,
            date: new Date(data.date),
            number: parseInt(data.number),
            rank: parseInt(data.rank),
          }))
        )
      })
      .catch((error) => console.error('Une erreur est survenue:', error))
  }, [selectedYear])

  useEffect(() => {
    // If the MF is not in the viewport, scroll to it
    if (ref && (selectedId || showPriceInfo)) {
      if (ref.getBoundingClientRect().top > 0) {
        ref.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } else if (ref.getBoundingClientRect().bottom < window.innerHeight) {
        ref.scrollIntoView({ behavior: 'smooth', block: 'end' })
      }
    }

    if (selectedId || showPriceInfo) {
      // console.log('Freeze body')
      //document.body.style.overflow = 'hidden !important'
      //document.body.style.borderTop = '1px solid red'
      //document.body.style.overflowY = 'hidden'
      document.body.style.setProperty('overflow', 'hidden', 'important')
      document.body.style.setProperty('height', '100%')
    } else {
      // console.log('Unfreeze body')
      //document.body.style.overflow = 'auto'
      //document.body.style.borderTop = '0'
      //document.body.style.overflowY = 'auto'
      document.body.style.setProperty('overflow', 'visible')
      document.body.style.setProperty('height', 'auto')
    }
  }, [selectedId, ref, showPriceInfo])

  const handleWaypoint = (category: string | null) => {
    setCategory(category)
  }

  const handleClick = (id: string) => {
    window.history.replaceState('', '', `?projet=${id}`)
    setSelectedId(id)
  }

  const handleInfoWindowClose = () => {
    window.history.replaceState(
      '',
      '',
      window.location.origin + window.location.pathname
    )
    setSelectedId(null)
    setShowPriceInfo(false)
  }

  return (
    <AppContainer $colorMode={colorMode} ref={setRef}>
      <ThemeProvider theme={theme}>
        <YearContext.Provider value={selectedYear}>
          <Cover />
          <IntroContent>
            <Intro>
              <Sub>Le prix</Sub>
              <Head>
                Le Prix de l’immobilier romand est un concours d’excellence qui
                récompense des projets immobiliers remarquables.
              </Head>
              <Text>
                Créé par le magazine Bilan en 2011, ce prix est depuis 2016
                co-organisé avec la section romande de l’Association suisse de
                l’économie immobilière SVIT, et le magazine économique.
              </Text>
            </Intro>
          </IntroContent>

          <Content>
            {!selectedId && !showPriceInfo && (
              <Menu
                style={{
                  position: isMobile
                    ? category
                      ? 'fixed'
                      : 'relative'
                    : 'sticky',
                }}
              >
                {!category && <MenuDropDown
                  handleCategoryChange={(value) => {
                    setSelectedYear(+value)
                  }}
                  category={selectedYear.toString()}
                  categories={['2023', '2024', '2025', '2026']}
                />}
                <MenuDropDown
                  handleCategoryChange={setSelectedCategory}
                  category={category}
                  categories={categories}
                />
                <ButtonMenuPrice
                  onClick={() => {
                    window.history.replaceState('', '', `?le-prix`)
                    setSelectedId(null)
                    setShowPriceInfo(true)
                  }}
                >
                  {category ? 'Le prix' : 'En savoir plus'}{' '}
                  {!category && (
                    <BsArrowRightShort
                      style={{ marginTop: '0.15em', marginLeft: '0.5em' }}
                    />
                  )}
                </ButtonMenuPrice>
              </Menu>
            )}

            <ProjectsList
              handleClick={handleClick}
              handleCategoryWaypoint={handleWaypoint}
              projects={data}
              scrollTo={selectedCategory}
              handleCategories={setCategories}
            />
          </Content>
          <InfoWindow
            itemData={data.find((item: any) => item.id === selectedId)}
            handleClose={handleInfoWindowClose}
          />
          <PriceInfo show={showPriceInfo} handleClose={handleInfoWindowClose} />
        </YearContext.Provider>
      </ThemeProvider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  min-height: 100vh;
  margin: 0 auto;
  background: #222222;
  color: white;
  -webkit-font-smoothing: antialiased;
  margin-bottom: 90px;
`

const CustomSelect = styled(animated.select)`
  // A reset of styles, including removing the default dropdown arrow
  appearance: none;
  // Additional resets for further consistency
  background-color: #f2f4f6;
  border: none;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  cursor: inherit;
  line-height: inherit;
  outline: none;
  color: ${(props) => props.theme.colorText};

  padding: 15px 20px;
  cursor: pointer;
  line-height: 1.2;
  padding-right: 50px;

  &:-ms-expand {
    display: none;
  }
`

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -320px;
`

const IntroContent = styled.div`
  background: #222222;
  color: ${(props) => props.theme.colorTextInverted};
  padding-bottom: 120px;
`

const Intro = styled.div`
  font-size: clamp(2.125rem, 1.557rem + 2vw, 4rem);
  line-height: 1.2;
  margin: 0;
  margin-bottom: 90px;
  -webkit-font-smoothing: antialiased;
  background: #151515;
  padding: 80px;
  padding-top: 160px;
  padding-bottom: 120px;
  box-sizing: border-box;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 15px;
    padding-top: 100px;
    padding-bottom: 160px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 80px;
    padding-top: 160px;
    padding-bottom: 160px;
  }
`

const Head = styled.div`
  font-size: 1.5em;
  line-height: 1;
  margin: auto;
  margin-top: 45px;
  max-width: 1024px;
`

const Sub = styled.div`
  font-size: 0.85em;
  text-align: center;
  color: ${({ theme }) => theme.colorGreyDark};

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    text-align: left;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    text-align: center;
  }
`

const Text = styled.div`
  font-size: 0.85em;
  margin: auto;
  margin-top: 65px;
  margin-bottom: 0px;
  max-width: 600px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    margin-top: 30px;
    margin-bottom: 25px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    margin-top: 65px;
    margin-bottom: 0px;
  }
`

const Menu = styled.div`
  position: sticky;
  top: 15px;
  bottom: auto;
  padding: 8px;
  background: #33333355;
  // box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
  border-radius: 11px;
  backdrop-filter: blur(10px);
  z-index: 99;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    position: relative;
    top: auto;
    bottom: 15px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    position: sticky;
    top: 15px;
    bottom: auto;
  }
`

const IconContainer = styled.div`
  background: ${(props) => props.theme.colorTextInverted};
  color: ${(props) => props.theme.colorText};
  width: 30px;
  height: calc(100% + 2px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 7px;
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 0 10px 10px 0;
  pointer-events: none;
`

const ButtonMenu = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  padding: 15px;
  background-color: ${(props) => 'transparent'};
  color: white;
  font-family: var(--font-sans-serif);
  font-size: 1em;
  font-weight: 400;
  text-transform: none;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  line-height: 1;
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 0.75em;
    padding: 15px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 1em;
    padding: 15px;
  }
`

const ButtonMenuPrice = styled(ButtonMenu)`
  background: ${(props) => props.theme.colorTextInverted};
  color: ${(props) => props.theme.colorText};
`

const MenuDropDown = ({
  category,
  categories,
  handleCategoryChange,
}: {
  category: string | null
  categories: string[]
  handleCategoryChange: (category: string) => void
}) => {
  const [width, setWidth] = useState(0)
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null)
  const spring = useSpring({
    value: width,
    config: { mass: 1, tension: 500, friction: 40 },
  })

  useLayoutEffect(() => {
    setWidth(category ? containerRef?.offsetWidth || 0 : 0)
  }, [category, containerRef])

  const Button = animated(ButtonMenu)

  return (
    <Button
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: 0,
        whiteSpace: 'nowrap',
        width: spring.value.to((v: any) => `${v}px`),
        borderWidth: category ? 1 : 0,
        marginRight: category ? 8 : 0,
      }}
    >
      <ButtonContent>
        <Template ref={setContainerRef}>{category}</Template>
        <CustomSelect
          style={{
            width: spring.value.to((v: any) => `${v}px`),
          }}
          value={category || ''}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
            handleCategoryChange(event.target.value)
          }}
        >
          {categories.map((item) => (
            <option key={`option-${item}`} value={item}>
              {item}
            </option>
          ))}
        </CustomSelect>
        <IconContainer>
          <RiArrowDropDownLine />
        </IconContainer>
      </ButtonContent>
    </Button>
  )
}

const ButtonContent = styled.div`
  position: relative;
  height: 100%;
`

const Template = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  padding: 15px 50px 15px 20px;
  transform: translateY(200px);
`

export default MainComponent
